


































import {Component, Vue} from 'vue-property-decorator'
import EditDialog from "@/component/Crud/edit-dialog.vue";
import {Container} from "typescript-ioc";
import RefreshButton from "@/component/Button/refresh-button.vue";
import ProductActivationApi, {PactStatistics} from "@/module/device/ProductActivationApi";
import productModule from "@/store/module/ProductModule";

@Component({
  components: {
    RefreshButton,
    EditDialog
  },
})
export default class PactStatisticsView extends Vue {

  private pactApi = Container.get(ProductActivationApi)

  private pactStatistics = new PactStatistics()

  private created() {
    this.getStatistic()
  }

  private get product() {
    return productModule.active
  }

  private async getStatistic() {
    this.pactStatistics = await this.pactApi.statistics(this.product.id)
  }

  private refresh() {
    this.getStatistic()
  }

  private get colNumber() {
    return 4
  }

  private cardClass(index: number) {
    switch (index % this.colNumber) {
      case this.colNumber:
        return "card-last"
      default:
        return "card"
    }
  }
}
